import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import {Routes, RouterModule, RouteReuseStrategy, PreloadAllModules} from '@angular/router';
import { NgChartsModule } from 'ng2-charts';
import { AgGridModule } from 'ag-grid-angular';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';

// feature modules
import {DnaModule} from './dna/dna.module';

// containers
import { AppComponent } from './app.component';

// components
import { AppNavComponent } from './layout/components/app-nav/app-nav.component';
import {ShockMtmValueComponent} from './dna/shared/components/shock-mtm-value/shock-mtm-value.component';
import {ToolBarComponent} from './layout/components/tool-bar/tool-bar.component';

// services
import {Store} from './store';
import {TimeRangeTailComponent} from './layout/components/time-range-tail/time-range-tail.component';
import {ModellingPanelComponent} from './layout/components/modelling-panel/modelling-panel.component';
import {TimeRangeTailConfigComponent} from './layout/components/time-range-tail-config/time-range-tail-config.component';
import {FormsModule} from '@angular/forms';
import { EntityTailConfigsComponent } from './layout/components/entity-tail-configs/entity-tail-configs.component';
import { SettingModalComponent } from './layout/components/setting-modal/setting-modal.component';
import { NewDerivativeCollateralModalComponent } from './layout/components/new-derivative-collateral-modal/new-derivative-collateral-modal.component';
import {CoreModule} from './core/core.module';
import { ModelInstrumentComponent } from './layout/components/model-instrument/model-instrument.component';
import { InstrumentColumnComponent } from './layout/components/instrument-column/instrument-column.component';
import { NotificationPopupComponent } from './layout/components/notification-popup/notification-popup.component';
import { QuotaModalComponent } from './layout/components/quota-modal/quota-modal.component';
import {SmallCcrChartComponent} from './dna/shared/components/small-ccr-chart/small-ccr-chart.component';
import {CustomRouteReuseStrategy} from './core/services/customRouteReuseStrategy';
import { NotificationPanelComponent } from './layout/components/notification-panel/notification-panel.component';
import { NotificationItemComponent } from './layout/components/notification-item/notification-item.component';
import { NotificationAlertComponent } from './layout/components/notification-alert/notification-alert.component';
import { SimulationSummaryModalComponent } from './layout/components/simulation-summary-modal/simulation-summary-modal.component';

import {
    AuthGuardService,
    AuthService,
    FrmkSsjsServicesModule, SsjsauthcallbackComponent,
    SsjslogoutComponent,
    SSOUser
} from '@frmk2sjs/services';
import {environment} from "../environments/environment";
import {HttpClientModule} from "@angular/common/http";
import { ErrorPopupComponent } from './layout/components/error-popup/error-popup.component';

const whiteListUrls: Array<string> = Array(
    '/isBackdoorActivated',
    '/data/loadOIDCParams'
);

export const ROUTES: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'overview'
    },
    {
        path: '**',
        redirectTo: ''
    }
];

@NgModule({
    declarations: [
        AppComponent,
        AppNavComponent,
        ToolBarComponent,
        TimeRangeTailComponent,
        TimeRangeTailConfigComponent,
        ModellingPanelComponent,
        EntityTailConfigsComponent,
        SettingModalComponent,
        NewDerivativeCollateralModalComponent,
        ModelInstrumentComponent,
        InstrumentColumnComponent,
        NotificationPopupComponent,
        QuotaModalComponent,
        NotificationPanelComponent,
        NotificationItemComponent,
        NotificationAlertComponent,
        SimulationSummaryModalComponent,
        ErrorPopupComponent
       ],
    imports: [
        BrowserModule,
        RouterModule.forRoot(ROUTES, {useHash: true /*, onSameUrlNavigation: 'reload' */, enableTracing: true }),
        FormsModule,
        CoreModule,
        ReactiveFormsModule,
        NgChartsModule,
        HttpClientModule,
        AgGridModule,
        DnaModule,
        NgbModule,
        //FrmkSsjsServicesModule.forRoot(environment.env, environment.backendUrl ) com isto nao chama o config
        FrmkSsjsServicesModule.forRoot(environment.env)
    ],
    exports:[AppNavComponent],
    providers: [
        Store,
        AuthService,
        {provide:AuthGuardService,useValue:AuthGuardService},
        SSOUser,
        SsjslogoutComponent,
        { provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy },
        {provide: 'back_end_url', useValue: environment.backendUrl},
        {provide: 'sso_params_service_path', useValue: '/api/data/loadOIDCParams'},
        {provide: 'ssjsWhitelist', useValue: whiteListUrls},
        {provide: 'resource_url', useValue: '/'},

    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    bootstrap: [AppComponent]
})
export class AppModule {
}
